import type { PageDef, RouteLoadProps, RouteParams } from './async-router';

/**
 * The key a loaded page would have at the next URL's params.
 *
 * A loaded page's params were processed when it loaded (student slugs
 * stripped to ids), so a copy of the next params is processed the same way
 * before computing the key. Comparing raw against processed never matches on
 * a slug URL: every navigation then reloads the page, and the mounted Page,
 * whose own key does match, discards what that reload fetched.
 */
export function nextPageKey(def: PageDef<any>, current: RouteLoadProps, params: RouteParams) {
  const nextParams = { ...params };
  def.processParams?.(nextParams);
  return def.key?.({ ...current, params: nextParams });
}
